import { EFrontElement } from "$src/CGS/domain/dto/core/EFrontElement";
import { FrontFaceMetadata } from "../Metadata/FrontFaceMetadata";
import { FrontElementMetadata, FrontMetadata } from "../Metadata/FrontMetadata";

export class GrooveObjectHelper {
    static hasTopGroove(frontFacesMetadata: FrontFaceMetadata[]): boolean {
        // Recherche toutes les rainures disponibles dans les métadonnées fournies
        const groovesMetadata = frontFacesMetadata
            .flatMap(ff => ff.FrontElements)
            .filter(this.isFrontElementMetadata)
            .filter((fe: FrontElementMetadata) => fe.Type === EFrontElement.G);

        // Vérifie si l'une de ces rainures est considérée comme "rainure supérieure"
        return groovesMetadata.some(gfe => this.isTopGrooveV1(frontFacesMetadata, gfe));
    }

    static isTopGrooveV1(frontFacesMetadata: FrontFaceMetadata[], grooveMetadata: FrontElementMetadata): boolean {
        return this.isTopGrooveV2(frontFacesMetadata.flatMap(ff => ff.FrontElements), grooveMetadata);
    }

    static isTopGrooveV2(frontMetadatas: FrontMetadata[], grooveMetadata: FrontElementMetadata): boolean {
        return frontMetadatas
        .filter(this.isFrontElementMetadata)
            .every((fe: FrontElementMetadata) => fe.Anchor.y <= grooveMetadata.Anchor.y);
    }

    static isFrontElementMetadata(fe: FrontMetadata): fe is FrontElementMetadata {
        return (fe as FrontElementMetadata).Type !== undefined;
    }
    
}
